import { DayKey } from '../components/ShiftSchedule';

const DAY_TO_INT: Record<DayKey, number> = {
  monday: 0,
  tuesday: 1,
  wednesday: 2,
  thursday: 3,
  friday: 4,
  saturday: 5,
  sunday: 6,
};

const INT_TO_DAY: Record<number, DayKey> = {
  0: 'monday',
  1: 'tuesday',
  2: 'wednesday',
  3: 'thursday',
  4: 'friday',
  5: 'saturday',
  6: 'sunday',
};

export function daysToIntegers(days: DayKey[]): number[] {
  return days.map((day) => DAY_TO_INT[day]);
}

export function integersToDays(integers: number[] | null): DayKey[] {
  if (!integers) return [];
  return integers.map((integer) => INT_TO_DAY[integer]);
}
